module.exports = __webpack_public_path__ + "img/celtic2.943ddb5e.jpg";